import { useEffect, useState, useCallback } from "react";
import { PageHeader } from "@/components/common/PageHeader";
import { DataTable, Badge } from "@/components/common/DataTable";
import { serviceService } from "@/services";
import { apiErrorMessage } from "@/lib/api";
import { toast } from "sonner";
import { Star } from "lucide-react";

function Stars({ n }) {
  return (
    <span className="inline-flex">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} className={`h-4 w-4 ${i <= n ? "text-amber-400 fill-amber-400" : "text-muted-foreground/30"}`} />
      ))}
    </span>
  );
}

export default function FeedbackPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [avg, setAvg] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try { const d = await serviceService.feedback({}); setRows(d.items || []); setAvg(d.avgRating); }
    catch (e) { toast.error(apiErrorMessage(e.response?.data?.detail)); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const columns = [
    { key: "rating", header: "Rating", render: (r) => <Stars n={r.rating} /> },
    { key: "comment", header: "Comment", render: (r) => <span className="text-foreground">{r.comment || "—"}</span> },
    { key: "channel", header: "Channel", render: (r) => <Badge color={r.channel === "public" ? "teal" : "blue"}>{r.channel}</Badge> },
    { key: "submittedAt", header: "Submitted", render: (r) => <span className="text-xs text-muted-foreground">{(r.submittedAt || "").slice(0, 16).replace("T", " ")}</span> },
  ];

  return (
    <div data-testid="feedback-page">
      <PageHeader title="Customer Feedback" subtitle="CSAT ratings from resolved tickets"
        actions={avg != null && (
          <div className="flex items-center gap-2 bg-card border border-border rounded-lg px-4 py-2" data-testid="feedback-avg">
            <span className="text-sm text-muted-foreground">Average</span>
            <span className="text-lg font-bold text-foreground">{avg}</span>
            <Star className="h-4 w-4 text-amber-400 fill-amber-400" />
          </div>
        )}
      />
      <DataTable columns={columns} rows={rows} loading={loading} testid="feedback-table" empty="No feedback yet" />
    </div>
  );
}
